import React, { useState, useEffect } from "react";
import profileImagee from "../../assests/images/default_avatar.png";
import userImage from "../../assests/images/userprofile.png";
import deletesImage from "../../assests/images/deleteprofile.png";
import { useNavigate, useParams } from "react-router-dom";
import { adminServices } from "../../services/adminServices";
import { UserObj } from "../../services/localStarage";
import { onboardingServices } from "../../services/onboardingServices";

function PersonalDetail() {
  const { id } = useParams();
  const [selectedFile, setSelectedFile] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [lastModified, setLastModified] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setprofileData] = useState('');
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    handleUpload(e.target.files[0]);
  };

  const handleUpload = (uploadFile) => {
    let formData = new FormData();
    formData.append("file", uploadFile);
    if (formData) {
      setIsLoading(true);
      onboardingServices
        .uploadFile(formData)
        .then(function (response) {
          const uploadKey = response?.data?.data?.data?.key;
          if (uploadKey) {
            let profilePic = {
              profilePic: uploadKey
            };
            let vId = UserObj?._id;
            adminServices
              .uploadFile(profilePic, id)
              .then(function (response) {
                if (response?.data?.success === true) {
                  setProfileImage((response?.data?.profilePic));
                  openAlert(true, "success", `${response?.data?.message}`);
                  setLastModified(`${response?.data?.updatedAt}`);
                  window.location.reload();
                }
              })
              .catch(function (error) {
                openAlert(true, "error", `${error?.response?.data?.message}`);
              })
              .finally((param) => {
                setIsLoading(false);
              });
          }
        })
        .catch(function (error) {
          openAlert(true, "error", error);
        });
    }
  };

  const handleDeleteImage = (e) => {
    if (profileData && profileData.profilePic) {
      let profilePic = {
        profilePic: ""
      };
      let vId = UserObj?._id;
      setIsLoading(true);
      adminServices
        .uploadFile(profilePic, id)
        .then(function (response) {
          if (response?.data?.success === true) {
            setProfileImage((response?.data?.profilePic));
            openAlert(true, "success", `${response?.data?.message}`);
            setLastModified(response?.data?.data?.updatedAt);
            window.location.reload();
          }
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message}`);
        })
        .finally((param) => {
          setIsLoading(false);
        });
      setProfileImage('');
      // setprofileData('');
      openAlert(true, "success", 'Uploaded file remove Successfully');
      setLastModified(null);
    } else {
      openAlert(true, "error", 'No image uploaded to delete. Please upload image first');
    }
  };

  useEffect(() => {
    getProfileDetails(id);
  }, [id]);

  const getProfileDetails = (loginId) => {
    setIsLoading(true);
    adminServices
      .getProfileData(loginId)
      .then((res) => {
        if (res.data.success === true) {
          setprofileData(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div>
            <div className="password_react_block_status_body">
              <div className="lets_head_purchase_vendor_isd">
                <div className="lets_head_purchase_vendor_profileies">
                  <div className="vendor_profilepic_id">
                    {selectedFile ? (
                      <img src={URL.createObjectURL(selectedFile)} className="profil_picc" alt="Profile pic" />
                    ) : (
                      profileData && profileData.profilePic ? (
                        <img src={profileData.profilePic} className="profil_picc" alt="Profile pic" />
                      ) : (
                        <img src={profileImagee} alt="Default Profile pic" className="profil_picc" />
                      )
                    )}
                    <div className="icon_vendor_detail_images">
                      {(id == UserObj?._id) && <div className="user_person_img">
                        <input type="file" id="fileInput" accept=".png, .jpg, .jpeg"
                          style={{ display: 'none' }}
                          onChange={handleFileChange}
                        />
                        <label htmlFor="fileInput">
                          <img src={userImage} alt="Upload Profile pic"
                            style={{ cursor: 'pointer' }} />
                        </label>
                        <img src={deletesImage} alt="Delete Profile pic" onClick={handleDeleteImage} style={{ cursor: 'pointer' }} />
                      </div>}
                    </div>

                  </div>
                  <div className="main_row_detail_lr_react_1">
                    <div className="lets_react_order_listing_level_profile">
                      <div className="content_react_level_details">
                        <p className="lets_block_react_details_purchaseprofile">
                          Personal and Contact Information
                        </p>
                      </div>
                      {/* <div className="profile_pending_react_body">
                    <SaveAsOutlinedIcon/>
                  Edit
                </div> */}
                    </div>
                    <div>
                      {/* <div class="account_hd">Profile Details</div> */}
                      <div className="card_body_react_deatils_box_block">
                        <div class="card-body">
                          <div className="lets_block_react_box_column">
                            <p className="lets_content_employee_block_userid">
                              Username
                            </p>
                            <p className="lets_employee_block_userid">  {profileData?.userName ? profileData.userName : ""}</p>
                          </div>

                          {UserObj.role.name === 'VENDOR' ? (
                            <>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Vendor ID
                                </p>
                                <p className="lets_employee_block_userid">
                                  {profileData?.vendorId ? profileData.vendorId : ""}
                                </p>
                              </div>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Title
                                </p>
                                <p className="lets_employee_block_userid"> {profileData?.title ? profileData.title : ""}</p>
                              </div>

                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Name
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.name ? profileData.name : ""}</p>
                              </div>

                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Contact Name
                                </p>
                                <p className="lets_employee_block_userid">
                                  {profileData?.vendorName ? profileData.vendorName : ""}
                                </p>
                              </div>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Contact Number
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.phoneNumber ? profileData.phoneNumber : ""}</p>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Employee Name
                                </p>
                                <p className="lets_employee_block_userid">
                                  {profileData?.name ? profileData.name : ""}
                                </p>
                              </div>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Phone Number
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.phoneNumber ? profileData.phoneNumber : ""}</p>
                              </div>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Email Id :
                                </p>
                                <p className="lets_employee_block_userid">
                                  {profileData?.email ? profileData.email : ""}
                                </p>
                              </div>
                            </>
                          )}

                          <div className="lets_block_react_box_column" style={{ borderBottom: 'none' }}>
                            <p className="lets_content_employee_block_userid">
                              Alternate Mobile Number
                            </p>
                            <p className="lets_employee_block_userid">{profileData?.alternatePhoneNumber ? profileData.alternatePhoneNumber : ""}</p>
                          </div>
                        </div>

                        <div class="card-body">

                          {UserObj.role.name !== 'VENDOR' ? (
                            <>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Date of birth
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.dateOfBirth ? formatDate(profileData.dateOfBirth) : ""}</p>
                              </div>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Employee Id
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.employeeId ? profileData.employeeId : ""}</p>
                              </div>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Department
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.department ? profileData.department : ""}</p>
                              </div>
                              <div className="lets_block_react_box_column" style={{ borderBottom: 'none' }}>
                                <p className="lets_content_employee_block_userid">
                                  Role
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.role ? profileData.role : ""}</p>
                              </div>
                            </>
                          ) : (

                            <>

                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Address
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.address ? profileData.address : ""}</p>
                              </div>

                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Email
                                </p>
                                <p className="lets_employee_block_userid">
                                  {profileData?.email ? profileData.email : ""}
                                </p>
                              </div>
                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Category
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.category ? profileData.category : ""}</p>
                              </div>

                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Business Type
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.businessType ? profileData.businessType : ""}</p>
                              </div>

                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Bank Name
                                </p>
                                <p className="lets_employee_block_userid">
                                  {profileData?.bankName ? profileData.bankName : ""}
                                </p>
                              </div>

                              <div className="lets_block_react_box_column">
                                <p className="lets_content_employee_block_userid">
                                  Bank Account Number
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.bankAccountNumber ? profileData.bankAccountNumber : ""}</p>
                              </div>
                              <div className="lets_block_react_box_column" style={{ borderBottom: 'none' }}>
                                <p className="lets_content_employee_block_userid">
                                  Bank IFSC
                                </p>
                                <p className="lets_employee_block_userid">{profileData?.bankIFSC ? profileData.bankIFSC : ""}</p>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>



    </>
  )
}

export default PersonalDetail